import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';

import { FormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { RegisterComponent } from './components/register/register.component';
import { UserComponent } from './components/user/user.component';
import { httpFactory } from './http-factory';
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import { UserService } from './services/user.service';
import { AuthService } from './services/auth.service';
import { LicenseService } from './services/license.service';
import { CustomerService } from './services/customer.service';
import { FeatureService } from './services/feature.service';
import {NgbModule, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateNativeAdapter } from './ngb-date-native-adapter';
import { AboutComponent } from './components/about/about.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { AuthGuardService } from './services/auth-guard.service';

import { OAuthModule } from 'angular-oauth2-oidc';
import { HttpClientModule } from '@angular/common/http'

// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { APP_CONFIG } from './app.config';
import { SharedModule } from './services/shared.module'
import { AdalService } from './services/adal.service';
import { environment } from 'environments/environment';
import { ChangeLogService } from './services/change-log.service';
import { ResetCloudPasswordComponent } from './components/reset-cloud-password/reset-cloud-password.component';
import { CloudPasswordService } from './services/cloud-password.service';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,    
    SharedModule,
    NgbModule.forRoot(),
    OAuthModule.forRoot(),
    HttpClientModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    UserComponent,
    //CustomerComponent,
    //FeatureComponent,
    //FeatureListComponent,
    //CustomerListComponent,
    //LicenseListComponent,
    //LicenseComponent,
    AboutComponent,
    ContactUsComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES
    // ChangeLogComponent,
    // ChangeLogListComponent
  ],
  providers: [
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, AdalService]
    },
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    UserService,
    AuthService,
    LicenseService,
    CustomerService,
    FeatureService,
    ChangeLogService,
    AuthGuardService,
    CloudPasswordService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_CONFIG, useValue: { 
        apiEndpoint: environment.apiEndpoint,             // WebAPI endpoint for Values
        clientId: environment.clientId,   // ClientID from AAD Client-App
        tenantId: environment.tenantId,   // AAD TenantID
        resource: environment.resource,   // ClientID from AAD Server-App
        redirectUri: environment.redirectUrl, // AAD Client-App's RedirectUri
        managementGid: environment.managementGid // AAD Group ID who can perform management actions
      }
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts